import { ITemplateScope } from "AngularFormly";
import { ListFieldController } from "../listFieldController";

export class InfoListFieldTypeController extends ListFieldController {
  static $inject = ["$scope"];
  constructor($scope: ITemplateScope) {
    super($scope);
  }
}
